import { combineReducers } from 'redux';
import { userReducer } from '../logic/user/UserRedux';

export const rootReducer = combineReducers({
  user: userReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
